import React from 'react';
import './index.scss';
import Disconnected from '../../../../assets/imgs/disconnected.png';
import { Typography } from '@mui/material';

function UnderMaintenanceComponent() {

    return (
        <>
            <div className='wrapperContactAdmin'>
                    <img
                        className='imgAdmin'
                        src={Disconnected}
                    />
                    <Typography className='mt-5 title'>
                        Maintenance
                    </Typography>
                    <Typography className='titleDesc'>
                        Mohon Maaf, 
                    </Typography>
                    <Typography className='titleDesc2'>
                        Halaman ini tidak dapat diakses, kami sedang dalam proses pemeliharaan sistem.
                    </Typography>
            </div>
        </>
    )
}

export default UnderMaintenanceComponent;
